import { PropsWithChildren } from 'react';

export const AdvantagesCard = ({ children }: PropsWithChildren) => (
  <div className="h-[170px] w-[312px] shrink-0 empty:hidden">{children}</div>
);

AdvantagesCard.displayName = 'AdvantagesCard';
